import {useEffect, useState} from "react";
import axios from "axios";
import { APIURL, AUTH_CREDENTIALS_NAME } from "../Constantes";
export const useCatPurchase = ({idPaquete}) =>{
    const getCabecera = () =>{
        let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
        let cabecera = { Authorization: `bearer ${Token}`,
        "Content-Type": "application/json",
        Accept: "application/json",}
        return cabecera;
    }
    const [data, setData] = useState({});
    useEffect(() =>{
        const getAPI = async () =>{
            try {
                const response = await axios.get(`${APIURL}/Catalog/CatPurchase/${idPaquete}`,
                {
                    headers: getCabecera()
                });
                switch (response.status) {
                    case 200:
                        setData(response.data)
                        break;
                    default:
                        setData({});
                        break;
                }
            } catch (error) {
                setData({});
            }
        }
        getAPI();
        return () =>{
            setData({});
        }
    },[idPaquete])
    return data;
}